import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import NavData from '@/config/data/nav/nav_data.json';
import { reporterDetail, getNewsList } from '@/network/apis/apiUri';
import useContent from '@/localization/data_export';
import useAxios from '@/network/useAxios';
import NewsWeather from './common/NewsWeather';
import '../news/css/news_reporter_main.scss';
import VideoThumbnail from '@/components/video-thumnail';
import BroadCastAt from '@/components/broadcast-at';

function NewsReporterMain() {
  const { mode } = useSelector((state) => state);
  const anchorTitle = useContent(['global', 'anchor', 'title']);
  const params = useParams();

  const id = params.reporterCode;

  const [page, setPage] = useState(0);
  const [newsData, setNewsData] = useState([]);

  const [reporterItem] = useAxios(reporterDetail, [], { reporter_id: id }, true);
  const [newsItem, newsRefetch] = useAxios(
    getNewsList,
    [],
    {
      reporter_id: id,
      page_info: {
        row_count: 20,
        number: 0,
      },
    },
    true
  );
  const { data: reporterData } = reporterItem;
  const { data: newsList } = newsItem;

  useEffect(() => {
    if (page)
      newsRefetch({
        reporter_id: id,
        page_info: {
          row_count: 20,
          number: page,
        },
      });
  }, [page]);

  useEffect(() => {
    if (newsList) setNewsData((prev) => [...prev, ...newsList.item]);
  }, [newsList]);

  return (
    <div id="NewsReporterMain" className="newsReporterMain">
      <NewsWeather pageTitle={'REPORTER'} />
      <section className="newsReporterMain_section profile">
        <div className="profile_profileBox profile">
          <div className="profile_link">
            <img
              src={`${reporterData?.image?.url}`}
              alt={reporterData?.name ? reporterData?.name.find((v) => v.lan_code === mode).text : 'reporter'}
              className="img"
              onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
            />
          </div>
          <div className="profile_text-warp text">
            <p className="text_top">Reporter</p>
            <h2 className="text_name">
              {reporterData?.name?.[0]?.lan_code === mode
                ? reporterData?.name?.[0]?.text
                : reporterData?.name?.[1].text}
            </h2>
            <p className="text_intro">{reporterData?.content?.[0]?.text}</p>
          </div>
        </div>
        <div className="profile_emailBox text">
          <a href={`mailto:${reporterData?.email}`}>{reporterData?.email}</a>
        </div>
      </section>
      <section className="newsReporterMain_section content">
        {newsData.length
          ? newsData.map((v, i) => (
              <div className="box" key={`reporter_${v.news_id}`}>
                <Link
                  to={`${NavData['NEWS_VIEW'].path}?id=${v.news_id}`}
                  style={{ display: 'block' }}
                  className="box_link"
                  title={anchorTitle}
                >
                  <div className="imgBox">
                    <VideoThumbnail thumbnail={v.image.url} duration={v.duration} className="img" />
                  </div>
                  <div className="textBox">
                    <h3
                      className="title"
                      dangerouslySetInnerHTML={{
                        __html:
                          mode === 'en'
                            ? v.title[0].text
                            : v.title[1].text === '' || v.title[1].text.length === 0
                            ? v.title[0].text
                            : v.title[1].text,
                      }}
                    />

                    <BroadCastAt at={v.broadcast_date} />
                  </div>
                </Link>
              </div>
            ))
          : false}
      </section>
      {newsList
        ? newsList.paging_info.total_item_count > newsData?.length && (
            <div className="btn-wrap">
              <button onClick={() => setPage(page + 1)}>More</button>
            </div>
          )
        : false}
    </div>
  );
}
export default NewsReporterMain;
